import { Link } from "react-router-dom";
import styled from "styled-components";
import FONTS from "../../constants/fonts";

export const PageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 5%;
`;

export const BelinsonHeader = styled.div`
  width: 100%;
  min-height: 10.4rem;
  background: #08183f;
  height: 10.4rem;
  padding: 2rem 4rem;
  display: flex;
  align-items: center;
  font-family: ${FONTS.UbuntuLight};
  font-size: 3.2rem;
  line-height: 3.6rem;
  letter-spacing: 1px;
  color: white;
  border-bottom: 0.4rem solid #ffffff33;
`;

export const OptionBox = styled.div`
  background: #ffffff;
  border: 4px solid #0096c6;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 54px;
  line-height: 118%;
  color: #474749;
  height: 100%;
  width: 100%;
`;
export const StyledLink = styled(Link)`
  width: 45%;
  height: 40%;
`;

export const BackBtnWrapper = styled.div`
  font-size: 24px;
  color: rgb(255, 255, 255);
  background-color: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  gap: 10px;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const VideosPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const CardsWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`;

export const CardContainer = styled.div`
  background: #ffffff;
  border-radius: 22px;
  width: 314px;
  height: 411px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  /* width: 33%; */
`;

export const VideoTitle = styled.div`
  color: #08183f;
  font-weight: 400;
  font-size: 34px;
`;

export const VideoPlayerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 72px;
  height: 100%;
`;

export const ThumbnailImg = styled.div`
  width: 222px;
  height: 222px;
  background-image: ${({ img }) => `url(${img})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const StyledCardLink = styled(Link)`
  margin-top: 15px;
  flex-basis: 33.33333%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
